import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(1)",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(0 1)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M27.016,32h-22a5.006,5.006,0,0,1-5-5V5a5.006,5.006,0,0,1,5-5h5.073a1,1,0,0,1,0,2H5.018a3,3,0,0,0-3,3V27a3,3,0,0,0,3,3h22a3.005,3.005,0,0,0,3-3v-4a3,3,0,0,0-3-2.995H8.995A3,3,0,0,0,6,22.995v4a1,1,0,0,1-2,0v-4A5,5,0,0,1,8.995,18H27.022a5,5,0,0,1,5,4.995v4A5.008,5.008,0,0,1,27.016,32Z",
				transform: "translate(-1.018 -1)",
				fill: "current"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M31.018,7.083a1,1,0,0,1-1-1V5a3,3,0,0,0-3-3h-1.06a1,1,0,1,1,0-2h1.06a5.006,5.006,0,0,1,5,5V6.083A1,1,0,0,1,31.018,7.083Z",
				transform: "translate(-1.018 -1)",
				fill: "current"
			})]
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 7,
			cy: 7,
			r: 7,
			transform: "translate(9.982)",
			fill: "current"
		})]
	})
});
export { SvgUsers as ReactComponent };
